import { render, staticRenderFns } from "./LoginComplaints.vue?vue&type=template&id=2067e593&scoped=true&"
import script from "./LoginComplaints.vue?vue&type=script&lang=js&"
export * from "./LoginComplaints.vue?vue&type=script&lang=js&"
import style0 from "./LoginComplaints.vue?vue&type=style&index=0&id=2067e593&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2067e593",
  null
  
)

export default component.exports